export interface InsuranceNotFoundCopy {
    heading: string
    body: string
    primaryAction: string
    secondaryAction: string
    secondaryActionDetail?: string
    supportAction: string
    returnToProfileAction: string
}

export interface InsuranceReviewCopy {
    heading: string
    singlePlanBody: string
    multiplePlanBody: string
    confirmAction: string
    rejectAction: string
    rejectMultipleAction: string
}

export interface InsuranceScanCopy {
    heading: string
    body: string
    uploadAction: string
    manualEntryAction: string
    withoutInsuranceAction: string
    illustrationOpensPicker: boolean
}

export interface InsuranceSearchCopy {
    heading: string
    body: string
    searchPrompt: string
    payerAction: string
    memberIdHelp: string
    memberIdHelpAction: string
    otherOptionsHeading: string
    withoutInsuranceAction: string
}

export interface InsuranceSearchLoadingCopy {
    loadingTitle: string
    confirmingTitle: string
    confirmingBody: string
    verifyingTitle: string
    verifyingBody: string
}

export interface InsuranceWithoutInsuranceModalCopy {
    title: string
    body: string
    continueAction: string
    continuePrice: string
}

export interface InsuranceCopy {
    notFound: InsuranceNotFoundCopy
    searchLoading: InsuranceSearchLoadingCopy
    withoutInsuranceModal: InsuranceWithoutInsuranceModalCopy
    review: InsuranceReviewCopy
    scan: InsuranceScanCopy
    search: InsuranceSearchCopy
}

export const generalMedicineInsuranceCopy: InsuranceCopy = {
    searchLoading: {
        loadingTitle: '',
        confirmingTitle: 'Checking your insurance',
        confirmingBody:
            'Just a moment while we check whether your insurance is in-network. This may take 15–30 seconds.',
        verifyingTitle: 'Verifying your insurance',
        verifyingBody:
            "We're verifying your insurance—most verifications take less than 30 seconds, but please allow up to 60 seconds.",
    },
    notFound: {
        heading: "We're having trouble verifying your insurance",
        body: '',
        primaryAction: 'Try another insurance',
        secondaryAction: 'Continue without insurance',
        secondaryActionDetail: 'Options starting at $35',
        supportAction: '',
        returnToProfileAction: 'Return to Profile',
    },
    review: {
        heading: 'Review',
        singlePlanBody: 'You have an insurance plan on file. Confirm if it is your current insurance.',
        multiplePlanBody: 'You have multiple insurance plans on file. Select your current insurance.',
        confirmAction: 'Confirm insurance',
        rejectAction: 'Not my insurance',
        rejectMultipleAction: 'None of these are my insurance',
    },
    scan: {
        heading: 'Add insurance card',
        body: '80% of customers pay $25 or less when they use insurance.',
        uploadAction: 'Upload photo',
        manualEntryAction: 'Enter manually',
        withoutInsuranceAction: 'Continue without insurance - $100',
        illustrationOpensPicker: false,
    },
    search: {
        heading: 'Find my insurance',
        body: 'Common insurance plans:',
        searchPrompt: 'Or search for another insurance',
        payerAction: 'Add insurance',
        memberIdHelp: 'May be shown as ID#, Member ID, or Subscriber ID on your insurance card or website',
        memberIdHelpAction: '',
        otherOptionsHeading: 'Other options',
        withoutInsuranceAction: 'Continue without insurance - $100',
    },
    withoutInsuranceModal: {
        title: 'You could save',
        body: '80% of customers pay $25 or less when they use insurance, and it only takes a minute.',
        continueAction: 'Continue without insurance',
        continuePrice: '$100',
    },
}
